export const DnDItemTypes = {
  CARD: 'card',
};
